<template>
    <div class="w-full">
        <ul class="flex flex-wrap items-center w-full">
            <li class="flex flex-nowrap items-center" :class="(categories.length > 0 || productName) ? `after:content-['\\e048'] after:font-icon rtl:after:rotate-180 after:text-sm after:mx-2` : ''">
                <router-link :to="{ name: rootRouteName }"
                    class="text-base font-medium capitalize transition-all duration-500 hover:text-primary gap-2 flex items-center">
                    <i class="lab-line-branches text-lg"></i>{{ $t(rootLabelKey) }}
                </router-link>
            </li>

            <li v-for="(category, categoryKey) in categories"
                :class="(categoryKey < categories.length - 1 || productName) ? `after:content-['\\e048'] after:font-icon rtl:after:rotate-180 after:text-sm after:mx-2` : ''">
                <router-link :to="{ name: 'frontend.product', query: { category: category.slug } }"
                    class="text-base font-medium capitalize transition-all duration-500 hover:text-primary">
                    {{ category.name }}
                </router-link>
            </li>

            <li v-if="productName" class="text-base font-medium capitalize text-text">
                {{ productName }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "CategoryBreadcrumbComponent",
    props: {
        categories: {
            type: Array,
            default: () => []
        },
        productName: {
            type: String,
            default: ''
        },
        rootRouteName: {
            type: String,
            default: 'frontend.product'
        },
        rootLabelKey: {
            type: String,
            default: 'label.products'
        }
    }
}

</script>